module.exports = __webpack_public_path__ + "assets/3a7a40bdcbd9d159661ed42836334af3.json";